import styled from 'styled-components'

export const Container = styled.div`
display: flex;
flex-direction: column;
max-width: 34.375rem;
overflow-y: auto;
`

export const FlexIcon = styled.div`
display: flex;
margin-bottom: .5rem;
strong{
    color:var(--Red);
    font-size: 14px;
}

svg,h4{
    margin-bottom: -.3rem;
}

svg{
    margin-right: .5rem;
    min-width: 2.5rem;
    margin-top: .4rem;
    margin-right: .375rem;
}

small{
font-family: 'Roboto','sans-serif';
font-weight: 700;
font-size: 12px;
}
`
